import { colors } from "constants/colors";
import { BarChartConfig } from "../ChartComponents";
import {
  EXPENSE_BAR_COLOR,
  EXPENSE_BAR_CROSS_LINE_COLOR,
  PROFIT_LOSS_LINE_COLOR,
  REVENUE_BAR_COLOR,
  REVENUE_BAR_CROSS_LINE_COLOR,
} from "constants/booksHomePage";

export const INFLOW_COLOR = colors.purple[30];
export const INFLOW_CROSS_LINE_COLOR = colors.purple[40];
export const OUTFLOW_COLOR = colors.neutral[20];
export const OUTFLOW_CROSS_LINE_COLOR = colors.neutral[30];
export const CASH_BALANCE_LINE_COLOR = colors.neutral.DEFAULT;

export const CASH_BALANCE_CONFIG: BarChartConfig = {
  colors: {
    bar1: OUTFLOW_COLOR,
    bar1CrossLine: OUTFLOW_CROSS_LINE_COLOR,
    bar1CrossLineOpacity: 0.6,
    bar2: INFLOW_COLOR,
    bar2CrossLine: INFLOW_CROSS_LINE_COLOR,
    bar2CrossLineOpacity: 0.3,
    line: CASH_BALANCE_LINE_COLOR,
  },
  labels: {
    bar1: "Outflow",
    bar2: "Inflow",
    line: "Net change",
  },
};

export const CASH_FLOW_CONFIG: BarChartConfig = {
  colors: {
    bar1: REVENUE_BAR_COLOR,
    bar1CrossLine: REVENUE_BAR_CROSS_LINE_COLOR,
    bar2: EXPENSE_BAR_COLOR,
    bar2CrossLine: EXPENSE_BAR_CROSS_LINE_COLOR,
    line: PROFIT_LOSS_LINE_COLOR,
  },
  labels: {
    bar1: "Revenue",
    bar2: "Expense",
    line: "Profit",
    lineNegative: "Loss",
  },
};
